import { createContext, useState } from 'react';

export const OrdersFilterAdminContext = createContext();

export const OrdersFilterAdminProvider = ({ children }) => {
  /* -------------------------------------------------------------------------- */
  /*                        ESTADOS PARA LAS SOLICITUDES                        */
  /* -------------------------------------------------------------------------- */
  const [statusFilter, setStatusFilter] = useState([]);
  const [centersFilter, setCentersFilter] = useState([]);
  const [createStartDateFilter, setCreateStartDateFilter] = useState(null);
  const [createEndDateFilter, setCreateEndDateFilter] = useState(null);
  const [deliveryStartDateFilter, setDeliveryStartDateFilter] = useState(null);
  const [deliveryEndDateFilter, setDeliveryEndDateFilter] = useState(null);
  const [orderFilter, setOrderFilter] = useState({});

  const data = {
    statusFilter,
    setStatusFilter,
    centersFilter,
    setCentersFilter,
    createStartDateFilter,
    setCreateStartDateFilter,
    createEndDateFilter,
    setCreateEndDateFilter,
    deliveryStartDateFilter,
    setDeliveryStartDateFilter,
    deliveryEndDateFilter,
    setDeliveryEndDateFilter,
    orderFilter,
    setOrderFilter,
  };

  return <OrdersFilterAdminContext.Provider value={data}>{children}</OrdersFilterAdminContext.Provider>;
};
